import { useTranslation } from 'react-i18next';

import { Label } from '@/components/ui/Label';
import { Switch } from '@/components/ui/Switch';

interface IntegrationSwitchProps {
  isActive: boolean;
  onToggleConfirmModal: () => void;
}

export function IntegrationSwitch({
  isActive,
  onToggleConfirmModal,
}: IntegrationSwitchProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.SeoContent.components.IntegrationForm',
  });

  return (
    <div className="flex items-center space-x-2">
      <Switch checked={isActive} onCheckedChange={onToggleConfirmModal} />
      <Label>{t('integrationSwitchLabel')}</Label>
    </div>
  );
}
